<div *ngIf="pin != null" class="pin-info-container pin-ambassador-container">
  <div class="pin-image">
    <img [src]="pin.avatar" alt="" />
  </div>

  <div class="pin-tags"></div>

  <div class="pin-title">
    {{ pin.name }}
  </div>

  <ul class="pin-description">
    <li>
      <mat-icon fontIcon="public" class="material-icons-outlined"></mat-icon>

      <span *ngIf="pin.city != null" [innerText]="pin.city + ','"></span>
      &nbsp;
      {{ pin.country }}
    </li>
  </ul>

  <div class="pin-button">
    <a [routerLink]="['/profile/' + pin.user + '/verified']" [innerHTML]="'HOMEPAGE.MAP.buttons.see_profile' | translate"></a>
  </div>
</div>
